(function () {
  "use strict";

  function cleanInterface() {
    document.documentElement.classList.add("km-luxury-ready");

    document.querySelectorAll("a").forEach(function (link) {
      if ((link.textContent || "").trim() || link.getAttribute("aria-label")) return;
      var image = link.querySelector("img[alt]");
      var label = image && image.alt ? image.alt.trim() : link.getAttribute("title");
      if (!label && link.getAttribute("href")) {
        try {
          var target = new URL(link.href, location.href);
          label = target.pathname === "/" ? "Inicio" : `Abrir ${target.pathname.split("/").filter(Boolean).pop().replace(/-/g, " ")}`;
        } catch {}
      }
      if (!label) label = "Abrir enlace";
      if (label) link.setAttribute("aria-label", label);
    });

    document.querySelectorAll("img").forEach(function (image) {
      var rawSource = image.getAttribute("src");
      if (!rawSource || image.src === location.href) {
        image.hidden = true;
        image.removeAttribute("src");
      }
    });

    document.querySelectorAll("input:not([aria-label])").forEach(function (input) {
      var label = input.placeholder || input.name || input.type;
      if (label) input.setAttribute("aria-label", label);
    });

    if (document.body.classList.contains("template-search") && !document.querySelector("main h1")) {
      var heading = document.createElement("h1");
      heading.className = "km-visually-hidden";
      heading.textContent = "Buscar en Kinetic Mobiles";
      var main = document.querySelector("main");
      if (main) main.prepend(heading);
    }

    var productHeading = document.querySelector(".product-details-content h1, .product-details-content h2");
    if (productHeading) {
      var fullTitle = productHeading.textContent.replace(/\s+/g, " ").trim();
      if (fullTitle.length > 68) {
        productHeading.setAttribute("aria-label", fullTitle);
        productHeading.textContent = fullTitle.split(/\s*[|,]\s*/)[0] || fullTitle;
      }
    }

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue.trim();
      if (value === "Bag") node.nodeValue = node.nodeValue.replace("Bag", "Carrito");
      if (/checkout seguro shopify/i.test(value)) {
        node.nodeValue = node.nodeValue.replace(/checkout seguro shopify/ig, "Pago protegido");
      }
    }

    document.querySelectorAll(".header-area a").forEach(function (link) {
      link.childNodes.forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) {
          child.nodeValue = child.nodeValue.replace(/^[\s\u267b\ufe0f\u{1f300}-\u{1faff}\u{1f1e6}-\u{1f1ff}]+/u, "");
        }
      });
      if (/\/pages\/descubre\/?$/.test(link.pathname)) link.style.setProperty("display", "none", "important");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cleanInterface, { once: true });
  } else {
    cleanInterface();
  }
})();
